import { NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";

const otherPageChildMenus: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/blog",
    name: "Blog Page",
  },
  {
    id: ncNanoId(),
    href: "/blog-single",
    name: "Blog Single",
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "About",
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Contact us",
  },
  {
    id: ncNanoId(),
    href: "/login",
    name: "Login",
  },
  {
    id: ncNanoId(),
    href: "/signup",
    name: "Signup",
  },
  {
    id: ncNanoId(),
    href: "/subscription",
    name: "Subscription",
  },
];

export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Αρχική",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/about",
    name: "Σχετικά με εμάς",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/contact",
    name: "Επικοινωνία",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/member",
    name: "Γίνε μέλος",
    isNew: true,
  },
  // {
  //   id: ncNanoId(),
  //   href: "/login",
  //   name: "Εγγραφή/Σύνδεση",
  //   isNew: true,
  // },
  // {
  //   id: ncNanoId(),
  //   href: "/subscription",
  //   name: "Γίνε συνεργάτης",
  //   isNew: true,
  // },
];
